var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-radio", {
                attrs: {
                  name: _vm.radioName,
                  checked: !_vm.computedValue,
                  label: _vm.$ct("boolean-value-false"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onBooleanInput(false)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-radio", {
                attrs: {
                  name: _vm.radioName,
                  checked: _vm.computedValue,
                  label: _vm.$ct("boolean-value-true"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onBooleanInput(true)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }